module.exports = __webpack_public_path__ + "static/media/Mudsdale_gaussian2.5c2d5828.png";